import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//Simple bar
import SimpleBar from "simplebar-react";
import { api_route } from "../../Api-config/config";
class LatestNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      tableData: [],
    };
  }

  componentDidMount() {
    this.fetchDashData();
  }

  fetchDashData = () => {
    fetch(api_route + "/user/news", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        id: sessionStorage.getItem("username"),
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({ tableData: json });

        console.log(json);
      });
  };

  render() {
    return (
      <React.Fragment>
        <Col lg={12}>
          <Card>
            <CardBody>
              {/* <Dropdown className="float-right" isOpen={this.state.menu} toggle={() => this.setState({menu : !this.state.menu})}>
                                            <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="false">
                                                <i className="mdi mdi-dots-vertical"></i>
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                
                                                <DropdownItem href="">Sales Report</DropdownItem>
                                                
                                                <DropdownItem href="">Export Report</DropdownItem>
                                                
                                                <DropdownItem href="">Profit</DropdownItem>
                                                
                                                <DropdownItem href="">Action</DropdownItem>
                                            </DropdownMenu>
                                        </Dropdown> */}

              <h4 className="card-title mb-4">
                Latest Trends In Unlisted Shares
              </h4>

              <SimpleBar style={{ maxHeight: "140px" }}>
                <ul className="list-unstyled activity-wid">
                  {this.state.tableData
                    .slice(0)
                    .reverse()
                    .map((itm) => (
                      <li className="activity-list">
                        <div className="activity-icon avatar-xs">
                          <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                            <i className="ri-edit-2-fill"></i>
                          </span>
                        </div>
                        <a href={itm.link} target="_blank">
                          <div>
                            <div>
                              <h5 className="font-size-13">
                                {new Date(parseInt(itm.date)).toDateString()}{" "}
                              </h5>
                            </div>

                            <div>
                              <p className="text-muted mb-0">{itm.title}</p>
                            </div>
                          </div>
                        </a>
                      </li>
                    ))}
                </ul>
              </SimpleBar>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

export default LatestNews;
